const isFrontPage = sendToJs.is_front_page;

const isHomePage = () => {
    const siteHeader = document.querySelector('.site-header');

    if (!isFrontPage || !siteHeader) return;

    siteHeader.classList.add('-no');
}

document.addEventListener('DOMContentLoaded', () => {
    isHomePage();
});